import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { MaterialStructureImport } from "shared";

export const startMaterialStructureImport = async (file: File): Promise<{ jobId: string }> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.materials.startMaterialStructureImport.mutation({
    body: formData,
  });

  if (response.status === 202) {
    return response.body;
  }

  throw new ApiError("Failed to import the material list", response.status, response.body);
};

export const fetchMaterialStructureImport = async (
  jobId: string,
): Promise<MaterialStructureImport> => {
  const response = await api.materials.findMaterialStructureImport.query({
    params: { jobId },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to fetch the material list import", response.status, response.body);
};
